import React, { useEffect, useRef, useState } from 'react';
import {
    useExternalClickTracking,
    useInstanceId,
    useTrackInscreen,
} from './hooks';
import Tracking from './tracking';

declare var _googCsa: any;

type GoogleAdProps = {
    ad: import('./types').Recommendation;
    trackAdClick: (adId: string, trackingUrlClick: string[]) => void;
    tracking: Tracking;
    position: string;
};
const GoogleAd: React.FC<GoogleAdProps> = (props) => {
    const { tracking, ad, position, trackAdClick } = props;

    const inscreenTrackingUrls = Tracking.getInscreenUrl(ad);
    const trackingUrlClick = Tracking.getClickUrl(ad);
    const [shouldFallback, setShouldFallback] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const domRef = useRef<HTMLDivElement>(null);
    useTrackInscreen({
        adId: ad.itemId,
        ref: domRef,
        tracking,
        enabled: loaded,
        inscreenTrackingUrls,
        pulseContext: ad?.tracking?.pulse,
    });
    const instanceId = useInstanceId((id) => `ad-stream__google-ad-${id}`);
    useEffect(() => {
        if (loaded) {
            // ensure a blink ad is never loaded twice, even in the edge case where the position changed
            return;
        }

        if ('_googCsa' in window === false) {
            setShouldFallback(true);
            return;
        }
        const pageOptions = {
            // @TODO get the final pubId's and styleId's
            pubId: 'vert-pla-scm-finn-no-pdp',
            styleId: '1050886310',
            query: ad.content.description,
            channel: 'feed',
            hl: 'no',
            adsafe: 'high',
            // We support click tracking even if we don't open links in new windows
            linkTarget: '_blank',
        };
        const { width, height } = domRef.current.getBoundingClientRect();

        const afshBlock = {
            container: instanceId,
            width,
            height,
            adLoadedCallback(containerName, adsLoaded) {
                if (adsLoaded) {
                    setLoaded(true);
                } else {
                    setShouldFallback(true);
                }
            },
        };

        _googCsa('plas', pageOptions, afshBlock);
    }, [
        ad.content.category,
        ad.content.description,
        instanceId,
        loaded,
        position,
    ]);

    useExternalClickTracking({
        adId: ad.itemId,
        ref: domRef,
        enabled: loaded,
        trackAdClick,
        trackingUrlClick,
        tracking,
        pulseContext: ad?.tracking?.pulse,
    });
    if (shouldFallback) {
        return null;
    }

    return (
        <div aria-hidden="true" className="ads__unit u-pa0">
            <div id={instanceId} className="u-fit-height" ref={domRef} />
        </div>
    );
};

export default GoogleAd;
